export type StepType = 'jupiter_swap' | 'bridge' | 'usdt_to_ton' | 'ton_to_spotty'

export type StepStatus = 'pending' | 'active' | 'submitted' | 'reconciling' | 'completed' | 'failed'

export interface Step {
  stepId?: string
  walletRequestId?: string
  type: StepType
  status: StepStatus
  txHash?: string | null
  depositTxHash?: string | null
  amountIn?: string | null
  amountOut?: string | null
  amountInExpected?: string | null
  amountOutExpected?: string | null
  startedAtMs?: number | null
  completedAtMs?: number | null
  askUnits?: string | null
  minAskUnits?: string | null
  routerMeta?: Record<string, unknown> | null
  label?: string
  provider?: string
  chainId?: number | null
  routeOrder?: number
}

export const findStep = (state: { steps: readonly Step[] }, type: StepType): Step | undefined =>
  state.steps.find((step) => step.type === type)

export interface EvmApprovalCheckpoint {
  walletRequestId: string
  approvalTxHash?: string | null
  swapId: string
  stepId: string
  walletAddress: string
  chainId: number
  quoteFingerprint: string
  tokenAddress: string
  spender: string
  requiredAmount: string
  completed: boolean
  status: 'invoked' | 'submitted' | 'completed' | 'reconciling'
}

export interface EvmBridgeCheckpoint {
  walletRequestId: string
  invokedAt?: string | null
  swapId: string
  stepId: string
  walletAddress: string
  chainId: number
  quoteFingerprint: string
  transactionTo?: string | null
  transactionDataHash?: string | null
  transactionValue?: string | null
  transactionNonce?: number | null
  startBlock?: number | null
  transactionHash?: string | null
  status: 'invoked' | 'submitted' | 'reconciling'
}

export interface PollingProviderMeta {
  rangoRequestId?: string | null
  layerswapSwapId?: string | null
}
